import { FirearmStorageLocationService } from '../model/firearm-storage-location.service';
import { CrudDataSource, HateoasMultipleResponseObject, PageSpecification } from '@scisys-uim/uim-common';
import { FirearmStorageLocation } from 'assets-model';
import { Observable } from 'rxjs';


export class FirearmStorageLocationDataSource extends CrudDataSource<FirearmStorageLocation> {

  constructor(private service: FirearmStorageLocationService) {
    super();
  }

  protected callLoaderService(serviceArguments: any, pageSpec: PageSpecification): Observable<HateoasMultipleResponseObject<FirearmStorageLocation>> {
    return this.service.findByFullFilters(serviceArguments, pageSpec);
  }

}


